import { ArrowRight } from "lucide-react";
import { tc, tb, tbr } from "../lib/themeStyles";

const TRUST = [
  "±0.005mm Tolerance",
  "25,000 sq ft Facility",
  "JNPT Port Proximity",
  "FOB · CIF · DDP",
  "VCI Anti-Rust Export Packaging",
  "SolidWorks · STEP · IGES",
  "ISO 9001:2015 Certified",
  "30+ Countries Exported",
];

export default function Hero() {
  return (
    <section
      id="top"
      className="relative cursor-cross min-h-[100svh] pt-[80px] flex flex-col justify-between overflow-hidden border-b"
      style={tbr.default}
    >
      <div className="absolute inset-0 grid-bg opacity-60" />
      <div className="noise-overlay" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(800px 500px at 80% 10%, rgba(59,130,246,0.1), transparent 60%)",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full flex-1 flex flex-col justify-center pt-8 pb-8">
        <div className="inline-flex items-center gap-2 self-start rounded-full px-3 py-1.5 glass mb-8 animate-fade-up">
          <span className="w-1.5 h-1.5 rounded-full animate-pulse_dot" style={tb.accentBright} />
          <span className="label-cap" style={tc.accent}>
            ISO 9001:2015 Certified
          </span>
        </div>

        <h1
          className="hero-title max-w-[1100px] animate-fade-up"
          style={{ animationDelay: "80ms", fontSize: "clamp(36px, 6vw, 68px)" }}
        >
          Precision Contract
          <br />
          Manufacturing. <span style={{ color: "#3b82f6" }}>Global.</span>
        </h1>

        <p
          className="mt-6 max-w-[640px] text-base leading-[1.7] animate-fade-up"
          style={{ ...tc.muted, animationDelay: "160ms" }}
        >
          CNC Machining · Heavy Fabrication · Sheet Metal Assemblies — built for international
          supply chains with tolerances measured in microns.
        </p>

        <div
          className="mt-10 flex flex-wrap items-center gap-4 animate-fade-up"
          style={{ animationDelay: "240ms" }}
        >
          <a href="#rfq" className="btn-primary">
            Submit RFQ <ArrowRight size={16} />
          </a>
          <a href="#capabilities" className="btn-ghost">
            View Capabilities <ArrowRight size={16} />
          </a>
        </div>
      </div>

      <div
        className="relative z-10 border-t overflow-hidden"
        style={{ ...tbr.default, background: "rgba(5, 5, 15, 0.6)" }}
      >
        <div className="marquee-track py-5">
          {[...TRUST, ...TRUST].map((t, i) => (
            <div key={i} className="flex items-center gap-3 px-8 shrink-0">
              <span className="w-1 h-1 rounded-full" style={tb.accentBright} />
              <span className="label-cap whitespace-nowrap" style={tc.muted}>
                {t}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
